import { render, staticRenderFns } from "./ManifestOutside.vue?vue&type=template&id=6cafe422&"
import script from "./ManifestOutside.vue?vue&type=script&lang=js&"
export * from "./ManifestOutside.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports